import anime from 'animejs/lib/anime.min.js';
import ScrollTrigger from '@terwanerik/scrolltrigger';
import Swiper, { Autoplay } from 'swiper';
import { CountUp } from 'countup.js';
import YTPlayer from 'youtube-player';

Swiper.use([Autoplay]);

export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS

    let homeHeroWord = {};
        homeHeroWord.opacityIn = [0,1];
        homeHeroWord.scaleIn = [0.2, 1];
        homeHeroWord.durationIn = 350;
        homeHeroWord.delay = 100;

    // All things web
    anime.timeline({ loop: false })
      .add({
        targets: '.hero-title .title-word-1',
        opacity: homeHeroWord.opacityIn,
        scale: homeHeroWord.scaleIn,
        duration: homeHeroWord.durationIn,
        delay: 500,
      }).add({
        targets: '.hero-title .title-word-2',
        opacity: homeHeroWord.opacityIn,
        scale: homeHeroWord.scaleIn,
        duration: homeHeroWord.durationIn,
        delay: homeHeroWord.delay,
      }).add({
        targets: '.hero-title .title-word-3',
        opacity: homeHeroWord.opacityIn,
        scale: homeHeroWord.scaleIn,
        duration: homeHeroWord.durationIn,
        delay: homeHeroWord.delay,
        complete: function() {
          // Period, snowflakes, flag, services
          anime.timeline({ loop: false })
            .add({
              targets: '.hero-title .title-period',
              opacity: homeHeroWord.opacityIn,
              duration: 800,
              delay: homeHeroWord.delay,
            });

          anime.timeline({ loop: false })
            .add({
              targets: '.hero-header .services',
              opacity: homeHeroWord.opacityIn,
              translateY: [-30, 0],
              duration: 800,
            });

          anime.timeline({ loop: false })
            .add({
              targets: '.home-hero .mountains-gfx .mtn-dots',
              opacity: homeHeroMtns.opacityIn,
              translateX: [433.171875, 433.171875],
              translateY: [-30, 9.256162],
              duration: 800,
            });

          anime.timeline({ loop: false })
            .add({
              targets: '.home-hero .mountains-gfx .flag-g',
              opacity: homeHeroMtns.opacityIn,
              translateX: [660.694137, 660.694137],
              translateY: [-30, 0],
              duration: 800,
            });
        },
      });

    let homeHeroMtns = {};
        homeHeroMtns.opacityIn = [0,1];
        homeHeroMtns.durationIn = 500;
        homeHeroMtns.delay = 100;

    anime.timeline({ loop: false })
      .add({
        targets: ['.home-hero .mountains-gfx .mtn-1', '.home-hero .mountains-gfx .mtn-3'],
        translateY: [90, 0],
      }).add({
        targets: '.home-hero .mountains-gfx .mtn-2',
        translateY: [130, 0],
        duration: homeHeroMtns.durationIn,
      }, '-100').add({
        targets: '.home-hero .mountains-gfx .mtn-trail',
        opacity: homeHeroMtns.opacityIn,
        duration: homeHeroMtns.durationIn,
      });


      /**
       * Mtns flag wave
       */

      // @todo



      /**
       * Video CTA
       * intro video
       */

      if ($('.video-cta .yt-player').length) {
        let $videoEl    = $('.video-cta .yt-player'),
            $videoFrame = $('.video-cta .video-frame'),
            $videoLink  = $('.video-cta-link'),
            $videoClose = $('.video-cta .video-frame .close');

        if ($videoEl.length) {
          let videoElId = $videoEl.attr('id'),
              videoId   = $videoEl.data('video-id'),
              videoPlayer;

          videoPlayer = new YTPlayer(videoElId, {
            videoId: videoId,
            playerVars: {
              controls:       1,
              showinfo:       0,
              rel:            0,
              autoplay:       0,
              loop:           1,
              mute:           0,
              fs:             0,
              modestbranding: 1,
            },
          });

          if ('undefined' !== typeof videoPlayer) {
            $videoLink.on('click', function(e) {
              e.preventDefault();
              $videoFrame.addClass('active');
              videoPlayer.playVideo();
            });

            $videoClose.on('click', function(e) {
              e.preventDefault();
              videoPlayer.stopVideo();
              $videoFrame.removeClass('active');
            });

            $(document).keyup(function(e) {
              if (e.keyCode == 27) {
                e.preventDefault();
                videoPlayer.stopVideo();
                $videoFrame.removeClass('active');
              }
            });
          }
        }
      }

      let videoCTA     = document.querySelector('.video-cta'),
          playSelector = '.fa-play-circle';

      if (videoCTA) {
        const videoCtaTrigger = new ScrollTrigger();
        videoCtaTrigger.add('.video-cta .video-cta-content', {
          once: false,
          offset: {
            viewport: {
              y: (trigger, frame, direction) => {
                frame,
                direction;

                return trigger.visible ? 0 : 0.4
              },
            },
          },
          toggle: {
            class: {
                in: 'active',
            },
            callback: {
              in: (trigger) => {

                anime.timeline({
                  loop: false,
                })
                  .add({
                    targets: playSelector,
                    opacity: [0, 1],
                    scale: [0.2, 1],
                    duration: 700,
                  })
                  .add({
                    targets: playSelector,
                    scale: [1, 0.9],
                    duration: 600,
                    complete: function() {
                      anime.timeline({
                        loop: true,
                        direction: 'alternate',
                        delay: 800,
                      })
                        .add({
                          targets: playSelector,
                          scale: [0.9, 1.1],
                          duration: 600,
                          delay: 800,
                        });
                    },
                  });

              },
              out: (trigger) => {


              },
            },
          },
        });
      }


      /**
       * Swipers
       */

      // Client strip

      const clientSwiper = new Swiper('#client-strip .swiper-container', {
        slidesPerView: 3,
        loop: true,
        spaceBetween: 45,
        centeredSlides: true,
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
        },
        speed: 3000,
        breakpoints: {
          992: { // lg+
            slidesPerView: 10,
          },
        },
      });


      /**
       * Stats
       */

      let statsNum = document.querySelector('#stats .stat');

      if (statsNum) {
        const statsCountUp = new ScrollTrigger();
        statsCountUp.add('#stats .stat', {
          once: false,
          offset: {
            viewport: {
              y: (trigger, frame, direction) => {
                frame,
                direction;

                return trigger.visible ? 0 : 0.2
              },
            },
          },
          toggle: {
            class: {
                in: 'active',
                out: [''],
            },
            callback: {
              in: (trigger) => {

                let countTo     = trigger.element.dataset.num,
                    countEl     = trigger.element.children[1].children[1], // span.count
                    statCountUp = new CountUp(countEl, countTo);

                if (!statCountUp.error) {
                  statCountUp.start();
                } else {
                  console.error(statCountUp.error);
                }

              },
              out: (trigger) => {

                let countEl = trigger.element.children[1].children[1]; // span.count
                countEl.innerHTML = 0;

              },
            },
          },
        });
      }

      /**
       * Stats snowflakes
       */

      let stats                = document.getElementById('stats'),
          statsSnowflakeTarget = '#stats .snowflake';

      let snowflakeWobble = function(snowflakesTarget) {
        anime({
          targets: snowflakesTarget,
          translateX: function() {
            return anime.random(-23, 23);
          },
          translateY: function() {
            return anime.random(-23, 23);
          },
          easing: 'easeInOutQuad',
          direction: 'alternate',
          duration: 2400,
          complete: function() {
            snowflakeWobble(snowflakesTarget);
          },
        });
      }

      snowflakeWobble(statsSnowflakeTarget);

      // if (stats) {
      //   const anime_Snowflake = new ScrollTrigger();
      //   anime_Snowflake.add(stats, {
      //     once: false,
      //     offset: {
      //       viewport: {
      //         y: (trigger, frame, direction) => {
      //           frame,
      //           direction;
      //
      //           return trigger.visible ? 0 : 0.25
      //         },
      //       },
      //     },
      //     toggle: {
      //       class: {
      //         in: 'inview',
      //         out: 'outview',
      //       },
      //       callback: {
      //         in: () => {
      //           anime.timeline({loop: false})
      //             .add({
      //               targets: statsSnowflakeTarget,
      //               opacity: [0, 0.5],
      //               translateY: [-30, 9.256162],
      //               easing: 'easeOutExpo',
      //               duration: 1200,
      //               delay: (el, i) => 120 * i,
      //               complete: function() {
      //                 snowflakeWobble(statsSnowflakeTarget);
      //               },
      //             });
      //         },
      //         out: () => {
      //           anime.timeline({loop: false})
      //             .add({
      //               targets: statsSnowflakeTarget,
      //               opacity: 0,
      //               translateY: -30,
      //               easing: 'easeInExpo',
      //               duration: 400,
      //               delay: (el, i) => 70 * i,
      //             });
      //         },
      //       },
      //     },
      //   });
      // }

      /**
       * Quotes snowflakes
       */

      let tQuotes                 = document.getElementById('testimonial-quotes'),
          tQuotesSnowflakeTarget = '#testimonial-quotes .snowflake';

      snowflakeWobble(tQuotesSnowflakeTarget);

      // if (tQuotes) {
      //   const anime_Snowflake2 = new ScrollTrigger();
      //   anime_Snowflake2.add(tQuotes, {
      //     once: false,
      //     offset: {
      //       viewport: {
      //         y: (trigger, frame, direction) => {
      //           frame,
      //           direction;
      //
      //           return trigger.visible ? 0 : 0.25
      //         },
      //       },
      //     },
      //     toggle: {
      //       class: {
      //         in: 'inview',
      //         out: 'outview',
      //       },
      //       callback: {
      //         in: () => {
      //           anime.timeline({loop: false})
      //             .add({
      //               targets: tQuotesSnowflakeTarget,
      //               opacity: [0, 0.5],
      //               translateY: [-30, 9.256162],
      //               easing: 'easeOutExpo',
      //               duration: 1200,
      //               delay: (el, i) => 120 * i,
      //               complete: function() {
      //                 snowflakeWobble(tQuotesSnowflakeTarget);
      //               },
      //             });
      //         },
      //         out: () => {
      //           anime.timeline({loop: false})
      //             .add({
      //               targets: tQuotesSnowflakeTarget,
      //               opacity: 0,
      //               translateY: -30,
      //               easing: 'easeInExpo',
      //               duration: 400,
      //               delay: (el, i) => 70 * i,
      //             });
      //         },
      //       },
      //     },
      //   });
      // }

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js